import 'es6-promise/auto';

import Vue from 'vue';
import vuetify from './setup/vuetify';
import './setup/sentry';
import './setup/vee-validate';

import Login from "./components/auth/Login";
import PasswordForgot from "./components/auth/PasswordForgot";
import PasswordReset from "./components/auth/PasswordReset";

Vue.component('login', Login);
Vue.component('password-forgot', PasswordForgot);
Vue.component('password-reset', PasswordReset);

const app = new Vue({
    el: '#auth',
    vuetify,
});
